import {
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonText,
  IonButton,
  IonRow,
  IonCol,
  IonGrid,
  IonCheckbox
} from '@ionic/react';
import { userProfileModel } from '../../../containers/ManageContainer/ManageUserContainer/ManageUserUtil';
import { IRole } from '../../../schemas/manage/manage.Schema';
import {
  ADD_PROFILE_PATH,
  FPC_MANAGE_USER_ROLES_WEB_FALLBACK,
  NO,
  OOPS_MESSAGE,
  PROFILE_FIELDS,
  PROFILE_FIELDS_PLACEHOLDER,
  REGISTER_ERROR_MESSAGE,
  REGISTER_LABEL_DESKTOP,
  restrict_LO3_user_modal_message,
  restrict_LO3_user_modal_title,
  ROLE_CONFIRMATION_LOO_FALLBACK,
  Roles,
  USER_FORM_ERRORS,
  YES
} from '../../../utils/constants';
import { ToastMessage } from '../../../utils/ToastMessage';
import React, { useEffect, useState } from 'react';
import { formatRoles, getSelectedRoles, roles, removeSpecial, getRequestedRoles } from './../../pages/userProfile/userProfileUtil';
import { IONICWrapper, isEntitled, validatePhoneNumberFormat } from '../../../utils/common';
import { getSessionId, logEvent, setScreenName } from '../../../utils/Analytics';
import MobileNumber from '../../../utils/MobileNumber/MobileNumber';
import { validateMobileNumberSchema } from '../../../schemas/App/MobileNumberValidate.Schema';
import { validateMobileNumber } from '../../../actions/App/action';
import { useDispatch } from 'react-redux';
import i18n from '../../../../i18n';
import { useLocation } from 'react-router';
import { normalizeInput } from '../../../pages/Manage/ManageUser/ManageUserUtil';
import { isAdminRole, isDispatcherRole, isDispatcherRoleOnly, isLeasedOwnerOprRole, isLeasedOwnerOprRoleOnlyOnRestricteduser, isNotALeasedOwnerOprRoleOnRestricteduser } from '../../../utils/roleUtil/RoleUtil';
import { EVENT, SCREEN, TAB } from 'app/utils/constants.analytics';
import { store } from 'app/store';

const ManageUserValidateForm = (props: any) => {
  const dispatch = useDispatch();
  const {
    selectedUser,
    mobileNumberError,
    formFields,
    isUserNotExist,
    reset
  } = props;
  const [roleSelection, setRoleSelection] = useState(JSON.parse(IONICWrapper?.details?.keys?.configuration?.fpc_manage_user_roles_web || FPC_MANAGE_USER_ROLES_WEB_FALLBACK) || roles);
  const [selectedCheckBox, setSelectedCheckBox] = useState([]);  
  const [roleErrorMsg, SetRoleErrorMsg] = useState(false); 
  const roleTitle = roleSelection
    .filter((role : IRole) => role.selected)
    .map((role : IRole) => role.label)
    .join(', ');
  const [showRoleOptions, setShowRoleOptions] = useState(false);
  const [isUserRoleAdmin, setUserRoleAdmin] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const [payloadCountryCode,setPayloadCountryCode] = useState<string>("");
  const [editMobileNumber, setEditMobileNumber] = useState(true);
  const [isValidateButton, setIsValidateButton] = useState(true);
  const defaultRoles = JSON.parse(IONICWrapper?.details?.keys?.configuration?.fpc_manage_user_roles_web || FPC_MANAGE_USER_ROLES_WEB_FALLBACK) || roles;
  const validateUserDetails : any= useLocation()
  useEffect(() => {
    if (props.submitable || props.addMode) {
      showRoleHandler(roles) ? validateNow(true): props.handleSubmit();
    }
  }, [props.onSave]);
  useEffect(() => {
   props.setFormFields({...formFields, roles:  props.formFields.roles});
    if((props.onClickRestrictUserModalNo || props.onClickRestrictUserModalYes || props.onClickRestrictUserModalNone) && props?.formFields?.roles?.length > 0)
    {
      props.onSave && props.handleSubmit()
    }
    }, [props.formFields.roles,props.onClickRestrictUserModalNo, props.onClickRestrictUserModalYes,props.onClickRestrictUserModalNone]);
  
useEffect(()=>
{
if(validateUserDetails?.state?.validateUserDetails && validateUserDetails?.pathname === ADD_PROFILE_PATH)
{
  setEditMobileNumber(true)
}
},[validateUserDetails])
useEffect(() => {
  let defaultselectedChecks: any = roleSelection.filter((role: any) => role.selected === true)?.filter((role: any) => role.label !== 'Admin');
  setSelectedCheckBox(defaultselectedChecks);
}, [roleSelection]);

  useEffect(() => {
    if (selectedUser) {
      const isCarrierAdmin = selectedUser?.userApplicationDetails && selectedUser?.userApplicationDetails[0]?.roles?.find((item: any) => item.roleName === 'carrierAdmin');
      const selectedRoles = defaultRoles.map((role: IRole) => ({
        ...role,
        selected: (selectedUser && selectedUser.userApplicationDetails && selectedUser.userApplicationDetails.length > 0 && selectedUser.userApplicationDetails[0].roles && selectedUser.userApplicationDetails[0].roles.some((item: any) => item.roleName === role.value.toString())) ?? false
      }));
      setRoleSelection(selectedRoles);
      setUserRoleAdmin(isCarrierAdmin);
    }
  }, [selectedUser]);
useEffect(() => {
    if (!isAdminRole()) {
      const selectedRoles = roles.map((role: IRole) => ({
        ...role,
        selected: (selectedUser?.userApplicationDetails?.length > 0 && selectedUser?.userApplicationDetails[0]?.roles.some((item: any) => item.roleName === role.value.toString())) ?? false
      }));
      const rolesinAdminRole = selectedRoles?.filter((role: any) => role.value !== Roles.carrierLeasedOwnerOpr);
      const rolesinDispatcherRole = defaultRoles?.filter((role: any) => {return role.value !== Roles.carrierLeasedOwnerOpr})?.map((role: IRole) => ({
        ...role,
        selected: (selectedUser?.userApplicationDetails?.length > 0 && selectedUser?.userApplicationDetails[0]?.roles.some((item: any) => item.roleName === role.value.toString())) ?? false
      }));
      isDispatcherRoleOnly() ? setRoleSelection(rolesinDispatcherRole) : setRoleSelection(isLeasedOwnerOprRole() ? selectedRoles : rolesinAdminRole);
  }
 },[])
  useEffect(() => {
    props.setFormFields({...formFields, roles: [],requestedRoles:''});
    setSelectedCheckBox([]);
    setScreenName("screen_ManageUser_validate_form");
    const rolesinAdminRole = defaultRoles?.filter((role: any) => role.value !==  Roles.carrierLeasedOwnerOpr);
    const rolesinDispatcherRole = defaultRoles?.filter((role: any) => {return role.value !== Roles.carrierLeasedOwnerOpr})?.map((role: IRole) => ({
      ...role,
      selected: (selectedUser?.userApplicationDetails?.length > 0 && selectedUser?.userApplicationDetails[0]?.roles.some((item: any) => item.roleName === role.value.toString())) ?? false
    }));
    if (reset) {
      !isAdminRole() ? isDispatcherRoleOnly() ? setRoleSelection(rolesinDispatcherRole) : setRoleSelection(rolesinAdminRole) : setRoleSelection(defaultRoles);
      setUserRoleAdmin(false);
      setShowRoleOptions(false);
      props.setReset(false);
    }
  }, [reset]);

  const mobileValidateHandler = () => {
    let { mobileNumber } = formFields;
    let mobileNumberWithCountryCode: string = formFields && formFields.mobileNumber && countryCode.concat(normalizeInput(mobileNumber));
    mobileNumber = removeSpecial(mobileNumberWithCountryCode);
    props.setFormFields({...formFields, countryCode: countryCode});
        const valMobileNumberSchema = new validateMobileNumberSchema({ phoneNumber: validatePhoneNumberFormat(mobileNumber), countryCode: payloadCountryCode});
      dispatch(validateMobileNumber({
        param: valMobileNumberSchema.validateMobileNumber(), callback: async (data: any) => {  
          if (data.msg === "success") {
            await props.setMobileValidateError(false);
              const callback = () => ToastMessage.show(OOPS_MESSAGE);
              const query = userProfileModel.validateUser(validatePhoneNumberFormat(mobileNumber));
              props.validateUserAction({ query, callback });
              setEditMobileNumber(false);
              props.setFormFields({ ...formFields, mobileNumber:mobileNumber})
              return true;
          }  else if(data.msg === "err") {
            await props.setMobileValidateError(true);
          } 
        }
      }))
  }

  const validateNow = (saveButton?:boolean) => {
    if(selectedCheckBox.length === 0){
      SetRoleErrorMsg(true);
    } else if(selectedCheckBox.length > 0) {
      SetRoleErrorMsg(false);
      if(restrictUserLO3(selectedCheckBox))
      {       
        const storeData = store.getState();
        const session = storeData && storeData.App && storeData.App.session;
        const sessionId = getSessionId(session.uuid);
        logEvent(EVENT.SV_ROLE_SELECTION_CONFIRMATION_MODAL, {
          screen: SCREEN.ROLE_SELECTION_CONFIRMATION_MODAL,
          sessionId: sessionId,
          lead: props.addMode? TAB.ADD_USER : TAB.MANAGE_USER,
          selectedRoles:getRequestedRoles(roleSelection).toString()
        });
        props.setOnClickRestrictUserModalYes(() => {return false}) 
        props.setOnClickRestrictUserModalNo(() => {return false})
        props?.setOnClickRestrictUserModalNone(() => {return false}) 
        props.setRestrictUserModalProps({
          isModalOpen: true,
          title: JSON.parse(IONICWrapper?.details?.keys?.configuration?.roleConfirmationLOOO || ROLE_CONFIRMATION_LOO_FALLBACK)?.title ||  restrict_LO3_user_modal_title,
          message: JSON.parse(IONICWrapper?.details?.keys?.configuration?.roleConfirmationLOOO || ROLE_CONFIRMATION_LOO_FALLBACK)?.message || restrict_LO3_user_modal_message,
          size : "medium_small",
          aditionalCssClass:"restrictLO3user",
          buttons: [
            {
              title: JSON.parse(IONICWrapper?.details?.keys?.configuration?.roleConfirmationLOOO || ROLE_CONFIRMATION_LOO_FALLBACK)?.primaryButtonTitle || NO,
              type: "primary-cta-btn-web",
              onClick: () => {
                props.setRestrictUserModalProps({isModalOpen: false})    
                props.setOnClickRestrictUserModalNo(() => {return true}) 
                props.setOnClickRestrictUserModalYes(() => {return false}) 
                props?.setOnClickRestrictUserModalNone(() => {return false}) 
                setRoleSelection(roleSelection?.map((role : IRole) => ({
                  ...role,
                  selected: role.value === Roles.carrierLeasedOwnerOpr ? false : role.selected
                }))) 
                props.setFormFields({
                  ...formFields,
                  roles: selectedUser? formatRoles(selectedUser.roles,roleSelection?.map((role : IRole) => ({
                    ...role,
                    selected: role.value === Roles.carrierLeasedOwnerOpr ? false : role.selected
                  }))?.filter((role: any) => role.label !== 'Admin')) :getSelectedRoles(roleSelection?.map((role : IRole) => ({
                    ...role,
                    selected: role.value === Roles.carrierLeasedOwnerOpr ? false : role.selected
                  })))?.filter((role: any) => role.label !== 'Admin'),
                });       
               !saveButton && mobileValidateHandler();   
               logEvent(EVENT.UE_ROLE_SELECTION_DECLINE, {
                screen: SCREEN.ROLE_SELECTION_CONFIRMATION_MODAL,
                sessionId: sessionId,
                lead: props.addMode? TAB.ADD_USER : TAB.MANAGE_USER,
                selectedRoles: getRequestedRoles(roleSelection?.map((role: IRole) => ({
                  ...role,
                  selected: role.value === Roles.carrierLeasedOwnerOpr ? false : role.selected
                }))).toString()
              });     
              }
            },
            {
              title: JSON.parse(IONICWrapper?.details?.keys?.configuration?.roleConfirmationLOOO || ROLE_CONFIRMATION_LOO_FALLBACK)?.secondaryButtonTitle || YES,
              type: "secondary-cta-btn-web",
              onClick: () => {
                props.setRestrictUserModalProps({isModalOpen: false})
                props.setOnClickRestrictUserModalYes(() => {return true})
                props.setOnClickRestrictUserModalNo(() => {return false}) 
                setRoleSelection(roleSelection?.map((role: IRole) => ({
                  ...role,
                  selected: role.value === Roles.carrierLeasedOwnerOpr ? true : false
                })))
                props.setFormFields({
                  ...formFields,
                  roles: selectedUser? formatRoles(selectedUser.roles,roleSelection?.map((role: IRole) => ({
                    ...role,
                    selected: role.value === Roles.carrierLeasedOwnerOpr ? true : false
                  }))?.filter((role: any) => role.label !== 'Admin')) :getSelectedRoles(roleSelection?.map((role: IRole) => ({
                    ...role,
                    selected: role.value === Roles.carrierLeasedOwnerOpr ? true : false
                  })))?.filter((role: any) => role.label !== 'Admin'),
                });
                !saveButton && mobileValidateHandler();
                logEvent(EVENT.UE_ROLE_SELECTION_CONFIRM, {
                  screen: SCREEN.ROLE_SELECTION_CONFIRMATION_MODAL,
                  sessionId: sessionId,
                  lead: props.addMode? TAB.ADD_USER : TAB.MANAGE_USER,
                  selectedRoles:getRequestedRoles(roleSelection?.map((role: IRole) => ({
                    ...role,
                    selected: role.value === Roles.carrierLeasedOwnerOpr ? true : false
                  }))).toString()
                }); 
              }
            }
          ]
        });
      }
      else {
        props.setRestrictUserModalProps({isModalOpen: false})
        props?.setOnClickRestrictUserModalNone(() => {return true}) 
        setRoleSelection(roleSelection?.map((role: IRole) => ({
          ...role,
          selected: role.selected
        })))
        saveButton && props.setFormFields({
          ...formFields,
          roles: selectedUser? formatRoles(selectedUser.roles,roleSelection?.map((role: IRole) => ({
            ...role,
            selected: role.selected
          }))?.filter((role: any) => role.label !== 'Admin')) :getSelectedRoles(roleSelection?.map((role: IRole) => ({
            ...role,
            selected: role.selected
          })))?.filter((role: any) => role.label !== 'Admin'),
        })
        !saveButton && mobileValidateHandler();
      }    
    }
    !saveButton && props.setMobileNumberError(true);

    if (!props.isNetworkAvailable) {
      props.showNetworkAlert();
      return true;
    }
    if (showRoleOptions) {
      setShowRoleOptions(false);
    }
  };

  const onFocus = (event: any, countryCde: string,countryName: string) => {
    const {name }= event.target;
    setCountryCode(countryCde);
    setPayloadCountryCode(countryName);
    if(name === 'mobileNumber') {
      props.setMobileValidateError(false);
    }
  }
  const restrictUserLO3 = (selectedRoles : any) =>
  {
       let  isRestrictUser = false
        if(isLeasedOwnerOprRoleOnlyOnRestricteduser(selectedRoles))
        {
          isRestrictUser = false
        }
        else
        {
          selectedRoles.map((roles:any) =>{
            if(isNotALeasedOwnerOprRoleOnRestricteduser(roles.value))
            {
              isRestrictUser = false 
            }
            else
            { isRestrictUser = true
            }
          })
        }
        return isRestrictUser
  }

  const mobileValidation = (mobilenumber: string, countryCde:string ,code:string) => {
    setCountryCode(countryCde && countryCde?countryCde:countryCode);
    setPayloadCountryCode(code && code ? code :payloadCountryCode);
  }

  const handleRoleSelection = (item: IRole) => {   
   props?.setOnClickRestrictUserModalYes(() => {return false}) 
   props?.setOnClickRestrictUserModalNo(() => {return false}) 
   props?.setOnClickRestrictUserModalNone(() => {return false})    
    const roleSelectionList = roleSelection.map((role: IRole) => ({
      ...role,
      selected: role.label === item.label ? !role.selected : role.selected
    }))?.filter((role: any) => role.label !== 'Admin');
    let selectedChecks: any = roleSelectionList.filter((role: any) => role.selected === true)?.filter((role: any) => role.label !== 'Admin');
    setSelectedCheckBox(selectedChecks);
    if(selectedChecks.length === 0){
      SetRoleErrorMsg(true);
      setIsValidateButton(true)
    } else if(selectedChecks.length > 0) {
      SetRoleErrorMsg(false);
      setIsValidateButton(false)
    };
    if (
      isUserRoleAdmin ||
      roleSelectionList.length > 0
    ) {
      const isDriver = roleSelectionList.find(
        (role: IRole) => role.selected && role.label === 'Driver'
      );
      props.setDriverSelected(!!isDriver);
      setRoleSelection(roleSelectionList);
      props.onClickRestrictUserModalYes  && setRoleSelection(roleSelection)      
      const roles = selectedUser
        ? formatRoles(selectedUser.roles, roleSelectionList)
        : getSelectedRoles(roleSelectionList);
        const requestedRoles = selectedUser
        ? formatRoles(selectedUser.roles, roleSelectionList)
        : getRequestedRoles(roleSelectionList) && getRequestedRoles(roleSelectionList).toString();
      selectedUser ? props.setFormFields({ ...formFields, roles}):props.setFormFields({ ...formFields, roles,requestedRoles});
      props.setFormEdit(true);
      const isonlyDriverSelected = roles.length === 1 && !!isDriver;
      props.setIsonlyDriverSelected(isonlyDriverSelected);
    }
  };

  const showRoleHandler = (roles: any) => {
    if(isAdminRole() || (isDispatcherRole() && roles.value !== 'carrierDispatcher')) return true;
    return false;
  }
 
  const roleSelectionRender = () => (
    <>
    <IonGrid class="select-role-grid">
        <IonRow class="select-role-label">{i18n.t(REGISTER_LABEL_DESKTOP.role)}</IonRow>
        <IonGrid class="role-suggetion-grid">
          {roleSelection.map((roles: any, index: number) => (
           
            showRoleHandler(roles) ? ( roles.displayFlag &&
            <IonRow
              key={index}
              class={"opt-row"}
            >

              <IonCheckbox
                class="checkbox-desktop"
                checked={roleSelection[index].selected}
                data-testid="roleCheckbox"
                onIonChange={e => handleRoleSelection(roles)}
              />
              <IonCol class="role-column">
                <IonLabel class="role-type">{" "}{i18n.t(roles.label)}</IonLabel>
                <IonRow class="role-desc">{i18n.t(roles.desc)}</IonRow>
              </IonCol>
            </IonRow>
          ) : null
          ))}
        </IonGrid>
        {showRoleHandler(roles) && roleErrorMsg ? <IonGrid class="errorGrid">{REGISTER_ERROR_MESSAGE.roleError}</IonGrid> : null}
      </IonGrid>
    </>
  );

  const mobileRender = () => (
    <>
      <MobileNumber
        mobileNumber={normalizeInput(formFields && formFields.mobileNumber)}
        mobileReadOnly={isUserNotExist}
        handleValueChange={props.handleChange}
        name="mobileNumber"
        placeholder={PROFILE_FIELDS_PLACEHOLDER.NEW_USER_NUMBER}
        label={PROFILE_FIELDS.MOBILE_NUMBER}
        mobileValidateError={props.mobileValidateError}
        onFocus={onFocus}
        addUser ={true}
        nonEditableField={!editMobileNumber ? true : false}
        mobileValidation = {mobileValidation}
      />
      {props.mobileValidateError && mobileNumberError ? (
        <IonText class="field-error" data-test="mobile-field-error">          
          {USER_FORM_ERRORS['mobileNumber']}
        </IonText>
      ) : null}
      {!isUserNotExist ? (
        <IonRow>
          <IonCol className="ion-margin-top">
          <IonButton
            className={'primary-cta-btn-web'}
            data-testid="validate-btn"
            onClick={() => validateNow()}
            disabled={isValidateButton || props.isValidateButton}
          >
            {PROFILE_FIELDS.CONTINUE}
          </IonButton>
          </IonCol>
          </IonRow>
      ) : null}
    </>
  );

  const renderForm = () => {
    if (props.isEdit && props.selectedUser.roles[0] === "carrierGuest") {
      return (
        <IonItem className={props.selectedUser ? 'role-info' : 'role-info-add'} key={PROFILE_FIELDS.ROLE}>
          <IonLabel className="user-profile-label" position="floating" mode="ios">{PROFILE_FIELDS.ROLE}</IonLabel>
          <IonInput
            value={isUserRoleAdmin
              ? `Admin${roleTitle.length > 0 ? `, ${roleTitle}` : ''}`
              : roleTitle || 'Guest'}
            readonly
            type="text"
            class="user-profile-input"
          ></IonInput>
        </IonItem>
      )
    } else if (props.isEdit) {
      return (
        <IonRow>
          <IonCol>{roleSelectionRender()}</IonCol>
        </IonRow>
      )
    } else {
      return (
        <IonList class="manage-userslist-form">
          <IonRow>
            <IonCol size={"12"}>{roleSelectionRender()}</IonCol>
            <IonCol size={"12"}>{mobileRender()}</IonCol>
          </IonRow>
        </IonList>
      )
    }
  }

  return renderForm();
};

export default ManageUserValidateForm;
